// removed by extract-text-webpack-plugin
module.exports = {"vadpLogin":"vadpLogin___3cygs","container":"container___1evGY","title":"title___1F09F","form":"form___210t_","autofill-fix":"autofill-fix___2Iszm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginBJZX/index.less
// module id = 347
// module chunks = 0